(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Theme editor
  // if (Shopify.designMode) {
  //   document.addEventListener('shopify:section:select', function(event) {
  //     if (event.target.classList.contains('site-header')) {
  //       document.documentElement.classList.add('scrolled');
  //     }
  //   });

  //   document.addEventListener('shopify:section:deselect', function(event) {
  //     if (event.target.classList.contains('site-header')) {
  //       document.documentElement.classList.remove('scrolled');
  //     }
  //   });
  // }

  } catch(e) { console.error(e); }
})();
})();
